<template>
	<div class='roboto'>
		<div class='title'>
			<div class='header'>
				<div class='header_title-container title'>
					<h1>{{ $t('change-password') }}</h1>
				</div>

				<div class='header_actions'>
					<div class='header_actions-container'>
						<el-button type='success' :disabled='error.length > 0' @click="handleSave('ruleForm')">
							{{ $t('save') }}
						</el-button>
						<el-tooltip placement='bottom'>
							<div slot='content'>{{ $t('cancel') }}</div>
							<el-button @click="handleReset('ruleForm')" circle size='small'>
								<md-icon>clear</md-icon>
							</el-button>
						</el-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div style='width: 100%' :style="{ height: height + 'px' }">
			<div style='width: 55%; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px'>
				<el-form
					:model='ruleForm'
					status-icon
					:rules='rules'
					ref='ruleForm'
					label-width='200px'
					class='demo-ruleForm'
				>
					<el-form-item prop='old' style='height: 60px'>
						<span slot='label'>{{ $t('old-password') }}</span>
						<el-input type='password' v-model='ruleForm.old' show-password />
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item prop='pass' style='height: 60px; margin-top: 35px'>
						<span slot='label'>{{ $t('new-password') }}</span>
						<el-input type='password' v-model='ruleForm.pass' show-password />
					</el-form-item>
					<el-form-item prop='checkPass' style='height: 60px'>
						<span slot='label'>{{ $t('retype-password') }}</span>
						<el-input type='password' v-model='ruleForm.checkPass' show-password />
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'change-password',
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('required-field')))
			} else {
				var res = this.ruleForm.pass.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g)
				if (!res) {
					callback(new Error(this.$t('password-error')))
				}
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass')
				}
				callback()
			}
		}

		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('required-field')))
			} else if (value != this.ruleForm.pass) {
				callback(new Error(this.$t('re-password-error')))
			} else {
				callback()
			}
		}

		var validateOld = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('required-field')))
			} else {
				callback()
			}
		}

		return {
			height: window.innerHeight - 285,
			reset: true,
			error: [],
			ruleForm: {
				old: '',
				pass: '',
				checkPass: ''
			},
			rules: {
				pass: [{ validator: validatePass, trigger: 'blur' }],
				checkPass: [{ validator: validatePass2, trigger: 'blur' }],
				old: [{ validator: validateOld, trigger: 'blur' }]
			}
		}
	},
	methods: {
		handleReset: function(ruleForm) {
			this.$refs[ruleForm].resetFields()
		},
		handleSave: async function(ruleForm) {
			this.$refs[ruleForm].validate(valid => {
				if (valid) {
					axios
						.post(
							process.env.VUE_APP_API_URL + '/api/user/forceChangePassword',
							{
								password: this.ruleForm.pass,
								actual_pwd: this.ruleForm.old
							},
							{ headers: { Authorization: 'Bearer ' + localStorage.getItem('JWT') } }
						)
						.then(res => {
							var jwt = res.data.jwt
							localStorage.setItem('JWT', jwt)
							this.$notification('success', this.$t('change-password-successful'), '', 4500)
						})
						.catch(err => {
							console.error(err)
							this.$notification('error', this.$t('change-password-error'), '', 0)
						})
				} else {
					return false
				}
			})
		}
	}
}
</script>

<style scoped lang='scss'>
@import "src/assets/scss/my-form";

h3 {
	font-family: "Montserrat", sans-serif;
}

.roboto {
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
</style>
